import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import Layout from './Layout/Layout'
import Homepage from './Pages/Homepage'
import Music from './Pages/Music'
import AlbumPage from './Pages/AlbumPage'
import About from './Pages/About'

function AppRoutes() {
  const location = useLocation()

  return (
    <Routes
      location={location}
      key={location.pathname}
    >
      <Route element={<Layout />}>
        <Route
          path='/'
          element={<Homepage />}
        />
        <Route
          path='/music'
          element={<Music />}
        />
        <Route
          path='/music/:albumSlug'
          element={<AlbumPage />}
        />
        <Route
          path='/about'
          element={<About />}
        />
      </Route>
    </Routes>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
